import { Flex, Text } from "@chakra-ui/react";
import _ from "lodash";
import { Boundary, SchoolBoundaries } from "src/components/Boundary/schemas";
import { ViewSchoolBoundaries } from "./ViewSchoolBoundaries";

export type Props = {
  boundaryMap: Immutable.Map<string, SchoolBoundaries> | undefined;
  schoolId: string;
  grades: {
    id: string;
  }[];
};
export const BoundaryInfo: React.FC<Props> = ({
  schoolId,
  boundaryMap,
  grades,
}: Props) => {
  const boundaries: Boundary[] = [];

  for (const id of [schoolId, ...grades.map((x) => x.id)]) {
    const b = boundaryMap?.get(id);
    if (b) boundaries.push(...b.boundaries);
  }

  const boundaryNames = _.sortBy(
    _.uniq(boundaries.map((b) => b.name ?? "<Unknown>"))
  ).filter((x) => x);

  if (!boundaryMap || boundaries.length < 1) return null;

  return (
    <>
      <Flex direction="column" gap={2} mt={2}>
        <Text fontSize="xs" color="gray.800">
          Boundaries in use
        </Text>
        <Text color="blackAlpha.700">{boundaryNames.join(", ")}</Text>
      </Flex>
      {boundaries && <ViewSchoolBoundaries boundaries={boundaries} />}
    </>
  );
};
